import { environment } from '../fetchEnv/env'
import { getBlaize } from '../getBlaize'

export type Entitlements = {
  tech: boolean
  money: boolean
  legal: {
    buying: boolean
    home: boolean
    holiday: boolean
    cars: boolean
    employment: boolean
    wills: boolean
    dataProtection: boolean
    medical: boolean
  }
}

type EntitlementCheckParams = {
  bookingType: string
  correlationId: string
  retryCounter?: number
  maxRetries?: number
}

const noEntitlements: Entitlements = {
  tech: false,
  money: false,
  legal: {
    buying: false,
    home: false,
    holiday: false,
    cars: false,
    employment: false,
    wills: false,
    dataProtection: false,
    medical: false,
  },
}
export const entitlementChecks = async ({
  bookingType,
  correlationId,
  retryCounter = 0,
  maxRetries = 2,
}: EntitlementCheckParams): Promise<Entitlements> => {
  const sessionId = getBlaize()
  if (!sessionId) {
    return noEntitlements
  }

  try {
    const response = await fetch(
      `https://${environment()}-appointment-booking-entitlements-validator.api.product.which.co.uk/user-entitlements?sessionId=${sessionId}`,
      {
        method: 'GET',
        headers: {
          Authorization: `${sessionId}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Forwarded-Application': `which-tool-framework/${environment()}`,
          'X-Booking-Type': bookingType,
          'X-Correlation-Id': correlationId,
          'User-Agent': window.navigator.userAgent,
        },
      }
    )

    if (!response.ok) {
      console.error(`API request failed: ${response.status} ${response.statusText}`)

      // Retry on server errors (500-599)
      if (response.status >= 500 && response.status < 600 && retryCounter < maxRetries) {
        await new Promise((resolve) => setTimeout(resolve, 500 * (retryCounter + 1)))
        return await entitlementChecks({
          bookingType,
          correlationId,
          retryCounter: retryCounter + 1,
        })
      }
      return noEntitlements
    }

    return await response.json()
  } catch (error) {
    if (retryCounter < maxRetries) {
      await new Promise((resolve) => setTimeout(resolve, 500 * (retryCounter + 1)))
      return await entitlementChecks({
        bookingType,
        correlationId,
        retryCounter: retryCounter + 1,
      })
    }

    return noEntitlements
  }
}
